import { Environment } from '../enums'

const APP_ENV = process.env.REACT_APP_ENV || Environment.DEVELOPMENT

// Per-environment fallbacks. Anything set in the matching .env file wins over
// these — they exist so a build with a missing var still points somewhere sane
// instead of silently falling back to localhost.
const defaults = {
  [Environment.DEVELOPMENT]: {
    API_ORIGIN: 'http://localhost:8082',
    APP_URL: 'http://localhost:3000',
    RESTAURANT_ADMIN_URL: 'http://localhost:3001',
    RESTAURANT_PUBLIC_URL: 'http://localhost:3000',
  },
  [Environment.STAGING]: {
    API_ORIGIN: 'https://api-stag.loyalideas.com',
    APP_URL: 'https://app-stag.loyalideas.com',
    RESTAURANT_ADMIN_URL: 'https://restaurant-admin-stag.loyalideas.com',
    RESTAURANT_PUBLIC_URL: 'https://order-stag.loyalideas.com',
  },
  [Environment.PRODUCTION]: {
    API_ORIGIN: 'https://api.loyalideas.com',
    APP_URL: 'https://app.loyalideas.com',
    RESTAURANT_ADMIN_URL: 'https://restaurant-admin.loyalideas.com',
    RESTAURANT_PUBLIC_URL: 'https://order.loyalideas.com',
  },
}

const fallback = defaults[APP_ENV] || defaults[Environment.DEVELOPMENT]

const trimSlash = (url) => (url || '').replace(/\/+$/, '')

// REACT_APP_API_URL holds the origin (https://api.loyalideas.com); callers of
// env.API_URL append '/v1' to it, so the '/api' segment is added here.
const apiOrigin = trimSlash(process.env.REACT_APP_API_URL) || fallback.API_ORIGIN

const env = {
  ENV: APP_ENV,
  API_URL: `${apiOrigin}/api`,
  APP_URL: trimSlash(process.env.REACT_APP_APP_URL) || fallback.APP_URL,
  RESTAURANT_ADMIN_URL:
    trimSlash(process.env.REACT_APP_RESTAURANT_ADMIN_URL) ||
    fallback.RESTAURANT_ADMIN_URL,
  RESTAURANT_PUBLIC_URL:
    trimSlash(process.env.REACT_APP_RESTAURANT_PUBLIC_URL) ||
    fallback.RESTAURANT_PUBLIC_URL,
}

export default env
